import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import authorization from './modules/authorization'
import reports from './modules/reports'
import groupsUsers from './modules/groupsUsers'
import statistic from './modules/statistic'
import news from './modules/news'
import packageStatistic from './modules/packageStatistic'
import productClient from './modules/productClient'
import arrOfIcons from '../components/json/arr_of_icons.json'
import dealers from './modules/dealers'

Vue.use(Vuex)

export const store = new Vuex.Store({
  strict: true,
  state: {
    servers: [],
    tabIndex: 0,
    showMenu: true,
    files: [],
    arrOfIcons: arrOfIcons,
    packageStatuses: null,
    packageDeliveryCodes: null,
    screenWidth: null,
    mobile: null,
    tablet: null,
    desktop: null,
    largeDesktop: null
  },
  getters: {
    userProfile: state => state.userInfo,
    mobile: state => state.mobile,
    tablet: state => state.tablet,
    desktop: state => state.desktop,
    largeDesktop: state => state.largeDesktop
  },
  actions: {
    loadPackageStatuses ({ commit }) {
      axios.get('/api/private/v3.0/list/package/statuses/')
        .then(response => response.data)
        .then(statuses => {
          commit('parsePackageStatuses', statuses)
        })
        .catch(error => {
          console.log(error.statusText)
        })
    },
    loadDeliveryCodes ({ commit }) {
      axios.get('/api/private/v3.0/list/package/deliveries/')
        .then(response => response.data)
        .then(codes => {
          commit('parsePackageDeliveryCodes', codes)
        })
        .catch(error => {
          console.log(error.statusText)
        })
    }
  },
  mutations: {
    setUserData (state, data) {
      state.userInfo = data
      state.servers = data.piportals
      localStorage.setItem('piportals', JSON.stringify(data.piportals))
    },
    tabPlus (state) {
      state.tabIndex++
    },
    tabMinus (state) {
      state.tabIndex--
    },
    toggleMenu (state) {
      if (state.showMenu) {
        state.showMenu = false
      } else {
        state.showMenu = true
      }
    },
    hideMenu (state) {
      state.showMenu = false
    },
    displayMenu (state) {
      state.showMenu = true
    },
    updateFiles (state, value) {
      for (let q = 0; q < value.length; q++) {
        value[q].icon = ''
        let ext = ''
        const parts = value[q].name.split('.')
        if (parts.length > 1) ext = parts.pop()
        for (const key in state.arrOfIcons) {
          if (ext.toLowerCase().indexOf(key) !== -1) {
            value[q].icon = state.arrOfIcons[key]
            break
          }
        }
        if (!value[q].icon) {
          value[q].icon = 'fas fa-file'
        }
      }
      state.files = value
    },
    parsePackageStatuses (state, value) {
      for (let i = 0; i < value.length; i++) {
        value[i].label = value[i].name
      }
      state.packageStatuses = value
    },
    parsePackageDeliveryCodes (state, value) {
      state.packageDeliveryCodes = value
    },
    updateScreenWidth (state, value) {
      state.screenWidth = value
    },
    updateMobile (state, value) {
      state.mobile = value
    },
    updateTablet (state, value) {
      state.tablet = value
    },
    updateDesktop (state, value) {
      state.desktop = value
    },
    updateLargeDesktop (state, value) {
      state.largeDesktop = value
    }
  },
  modules: {
    authorization,
    groupsUsers,
    statistic,
    reports,
    news,
    packageStatistic,
    productClient,
    dealers
  }
})
